import {
  SET_LOG_LIST,
  SET_LOG_PAGE_TOTAL,
  SET_LOG_QUERY,
  SET_LOG_PAGE_SIZE,
  SET_LOG_PAGE_NUM,
  SET_LOG_SEARCHING,
  RESET_LOG_LIST,
} from './mutation-types.js'
import api from '@/api'
import _ from 'lodash'
import { format } from 'date-fns'
import { checkUserName } from '@/views/User/utils'
import { normalizeRenderTaskIds } from '@/views/Monitor/utils/normalize-task-ids'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  userName: '',
  operatedUserName: '',
  startDate: `${format(new Date(+new Date() - 3600 * 1000 * 24 * 30), 'yyyy-MM-dd')} 00:00:00`,
  endDate: `${format(new Date(), 'yyyy-MM-dd')} 23:59:59`,
  userId: '',
  buttonNameList: [],
  taskType: '',
  taskIds: '',
  adminId: '', // 管理员id
  nodeIp: '', // 节点机ip
  userType: '',
  channel: '',
  nodeIds: '',
})

const state = {
  initQuery: initQuery(),
  searching: false,
  log: {
    list: [],
    emptyText: '默认不显示列表，请通过查询搜索',
    listPageTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_LOG_LIST](state, payload) {
    state.log.list = payload
    state.log.emptyText = '暂无数据'
  },
  [RESET_LOG_LIST](state) {
    state.log.list = []
    state.log.emptyText = '默认不显示列表，请通过查询搜索'
  },
  [SET_LOG_PAGE_TOTAL](state, payload) {
    state.log.listPageTotal = payload
  },
  [SET_LOG_QUERY](state, payload) {
    state.log.query = {
      ...state.log.query,
      ...payload,
    }
  },
  [SET_LOG_PAGE_SIZE](state, payload) {
    state.log.query.pageSize = payload
  },
  [SET_LOG_PAGE_NUM](state, payload) {
    state.log.query.pageNum = payload
  },
  [SET_LOG_SEARCHING](state, payload) {
    state.searching = payload
  },
}

const actions = {
  async getOperateLog({ commit, state, dispatch }, payload) {
    try {
      let query = {}
      _.forIn(state.log.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        ...payload,
      }
      if (!params.taskType) return
      if (payload && !payload.userName && params.userName) {
        delete params.userName
      }
      params.taskIds = normalizeRenderTaskIds(params.taskIds)
      commit(SET_LOG_SEARCHING, true)
      let { data, code } = await api.monitorApi.getOperateLog(params)
      checkUserName({
        code,
        data,
        callback: ({ userId }) => {
          const { userName, ...other } = params
          dispatch('getOperateLog', {
            ...other,
            userId,
          })
        },
      })
      const { items, total } = data
      items &&
        items.map((val) => {
          if (val.taskIds) {
            val.taskIds =
              val.taskIds.indexOf('[') > -1 ? JSON.parse(val.taskIds) : val.taskIds.split(',')
          } else val.taskIds = []
        })
      commit(SET_LOG_LIST, items)
      commit(SET_LOG_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_LOG_LIST, [])
      commit(SET_LOG_PAGE_TOTAL, 0)
    }
    commit(SET_LOG_SEARCHING, false)
  },
  setLogQuery({ commit, state }, payload) {
    commit(SET_LOG_QUERY, payload)
  },
  setPageSize({ commit, dispatch }, payload) {
    commit(SET_LOG_PAGE_SIZE, payload)
    commit(SET_LOG_PAGE_NUM, 1)
    dispatch('getOperateLog')
  },
  setPageNum({ commit, dispatch }, payload) {
    commit(SET_LOG_PAGE_NUM, payload)
    dispatch('getOperateLog')
  },
  changeLogQuery({ commit, dispatch }, payload) {
    commit(SET_LOG_PAGE_NUM, 1)
    dispatch('getOperateLog')
  },
  // 重置 list
  resetOperateLog({ commit }) {
    commit(RESET_LOG_LIST)
    commit(SET_LOG_PAGE_TOTAL, 0)
  },
  async getHardwareMode({ commit }, payload) {
    let data = await api.monitorApi.getHardwareMode(payload)
    return data
  },
  // 根据操作记录类型查询全部操作项
  async getOperationItems ({state, commit}, payload) {
    const params = {
      taskType: state.log.query.taskType,
    }
    let { data } = await api.monitorApi.queryOperationItems(params)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
